import React from 'react';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
  badge?: number | string;
}

export interface TabsProps {
  items?: TabItem[];
  tabs?: TabItem[];
  activeId?: string;
  onChange?: (id: string) => void;
  children?: React.ReactNode;
  className?: string;
}

export const Tabs = ({ items, tabs, activeId, onChange, children, className = '' }: TabsProps) => {
  const tabItems = items ?? tabs ?? [];
  const currentActiveId = activeId ?? tabItems[0]?.id;

  return (
    <div className="space-y-4">
      <div className={`flex items-center gap-1 overflow-x-auto p-1 bg-slate-100 rounded-md no-scrollbar ${className}`}>
        {tabItems.map((tab) => {
          const isActive = currentActiveId === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange?.(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 sm:text-sm text-xs rounded-md transition-all whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-500 hover:text-slate-700 hover:bg-slate-200/50'
              }`}
            >
              {tab.icon && <i className={`${tab.icon} ${isActive ? 'text-brand-600' : ''}`} />}
              {tab.label}
              {tab.badge !== undefined && (
                <span className={`px-2 py-0.5 text-[10px] rounded-full ${isActive ? 'bg-brand-50 text-brand-600' : 'bg-slate-200 text-slate-600'}`}>
                  {tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {children}
    </div>
  );
};
